import React from 'react';
import PropTypes from 'prop-types';

import OutputText from '@ey/canvascoreservices/OutputText';

import RiskTypeAbbreviationDisplay from '../RiskTypeAbbreviationDisplay';
import StyledRiskNameDisplay from './StyledRiskNameDisplay';

const RiskNameDisplay = ({typeId = null, name = null, multiline = 0}) => (
	<StyledRiskNameDisplay>
		{typeId && <RiskTypeAbbreviationDisplay id={typeId} />}
		{name && (
			<OutputText body2 ellipsis title={name} multilineEllipsis={multiline}>
				{name}
			</OutputText>
		)}
	</StyledRiskNameDisplay>
);

RiskNameDisplay.propTypes = {
	typeId: PropTypes.oneOf([1, 2, 3]),
	name: PropTypes.string,
	multiline: PropTypes.number
};

export default RiskNameDisplay;
